"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowItemSimulationSupplierDTO_1 = require("../model/WindowItemSimulationSupplierDTO");

var WindowItemSimulationSupplierDTOConverter_1 = require("./WindowItemSimulationSupplierDTOConverter");
/**
 * @author Adam Drda
 */


var WindowItemSimulationSupplierDTOConverterImpl =
/*#__PURE__*/
function (_WindowItemSimulation) {
  _inherits(WindowItemSimulationSupplierDTOConverterImpl, _WindowItemSimulation);

  function WindowItemSimulationSupplierDTOConverterImpl() {
    _classCallCheck(this, WindowItemSimulationSupplierDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSimulationSupplierDTOConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemSimulationSupplierDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowItemSimulationSupplierDTO_1.WindowItemSimulationSupplierDTO(WindowItemSimulationSupplierDTO_1.WindowItemSimulationSupplierDTO.schema.preferredPromoPurchasePrice.valueOf(conversions.toBigNumber(source.preferredPromoPurchasePrice)), WindowItemSimulationSupplierDTO_1.WindowItemSimulationSupplierDTO.schema.preferredPromoPurchaseStartDate.valueOf(source.preferredPromoPurchaseStartDate ? conversions.toDate(source.preferredPromoPurchaseStartDate) : null), WindowItemSimulationSupplierDTO_1.WindowItemSimulationSupplierDTO.schema.preferredUnitBackDiscount.valueOf(source.preferredUnitBackDiscount ? conversions.toBigNumber(source.preferredUnitBackDiscount) : null), WindowItemSimulationSupplierDTO_1.WindowItemSimulationSupplierDTO.schema.preferredSupplierId.valueOf(conversions.toClassReferenceId(source.preferredSupplierId)), WindowItemSimulationSupplierDTO_1.WindowItemSimulationSupplierDTO.schema.preferredCurrencyId.valueOf(conversions.toClassReferenceId(source.preferredCurrencyId)), WindowItemSimulationSupplierDTO_1.WindowItemSimulationSupplierDTO.schema.preferredRegularPurchasePrice.valueOf(conversions.toBigNumber(source.preferredRegularPurchasePrice)), WindowItemSimulationSupplierDTO_1.WindowItemSimulationSupplierDTO.schema.preferredRegularPurchasePriceNett.valueOf(conversions.toBigNumber(source.preferredRegularPurchasePriceNett)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        preferredPromoPurchasePrice: conversions.fromBigNumber(source.preferredPromoPurchasePrice),
        preferredPromoPurchaseStartDate: source.preferredPromoPurchaseStartDate ? conversions.fromDate(source.preferredPromoPurchaseStartDate) : null,
        preferredUnitBackDiscount: source.preferredUnitBackDiscount ? conversions.fromBigNumber(source.preferredUnitBackDiscount) : null,
        preferredSupplierId: conversions.toDocumentReferenceId(source.preferredSupplierId),
        preferredCurrencyId: conversions.toDocumentReferenceId(source.preferredCurrencyId),
        preferredRegularPurchasePrice: conversions.fromBigNumber(source.preferredRegularPurchasePrice),
        preferredRegularPurchasePriceNett: conversions.fromBigNumber(source.preferredRegularPurchasePriceNett)
      });
      return result;
    }
  }]);

  return WindowItemSimulationSupplierDTOConverterImpl;
}(WindowItemSimulationSupplierDTOConverter_1.WindowItemSimulationSupplierDTOConverter);

exports.WindowItemSimulationSupplierDTOConverterImpl = WindowItemSimulationSupplierDTOConverterImpl;